import { render, staticRenderFns } from "./UntrustedDomain.vue?vue&type=template&id=2b4164c1&scoped=true"
import script from "./UntrustedDomain.vue?vue&type=script&lang=js"
export * from "./UntrustedDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4164c1",
  null
  
)

export default component.exports